import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { ptBRCommon } from './locales/pt-BR/common';
import { enUSCommon } from './locales/en-US/common';
import { ptBRExpenses } from './locales/pt-BR/expenses';
import { enUSExpenses } from './locales/en-US/expenses';
import { ptBRBills } from './locales/pt-BR/bills';
import { enUSBills } from './locales/en-US/bills';
import { ptBRDashboard } from './locales/pt-BR/dashboard';
import { enUSDashboard } from './locales/en-US/dashboard';
import { ptBRCategories } from './locales/pt-BR/categories';
import { enUSCategories } from './locales/en-US/categories';
import { ptBRAccounts } from './locales/pt-BR/accounts';
import { enUSAccounts } from './locales/en-US/accounts';
import { ptBRSettings } from './locales/pt-BR/settings';
import { enUSSettings } from './locales/en-US/settings';
import { ptBRReports } from './locales/pt-BR/reports';
import { enUSReports } from './locales/en-US/reports';
import { ptBROnboarding } from './locales/pt-BR/onboarding';
import { enUSOnboarding } from './locales/en-US/onboarding';
import { ptBRBackstage } from './locales/pt-BR/backstage';
import { enUSBackstage } from './locales/en-US/backstage';
import { ptBRHouseholdItems } from './locales/pt-BR/household-items';
import { enUSHouseholdItems } from './locales/en-US/household-items';
import { ptBRLists } from './locales/pt-BR/lists';
import { enUSLists } from './locales/en-US/lists';
import { ptBRAgenda } from './locales/pt-BR/agenda';
import { enUSAgenda } from './locales/en-US/agenda';
import { ptBROauth } from './locales/pt-BR/oauth';
import { enUSOauth } from './locales/en-US/oauth';

export const SUPPORTED_LOCALES = ['pt-BR', 'en-US'] as const;
export type SupportedLocale = typeof SUPPORTED_LOCALES[number];

export const resources = {
  'pt-BR': {
    common: ptBRCommon,
    expenses: ptBRExpenses,
    bills: ptBRBills,
    dashboard: ptBRDashboard,
    categories: ptBRCategories,
    accounts: ptBRAccounts,
    settings: ptBRSettings,
    reports: ptBRReports,
    onboarding: ptBROnboarding,
    backstage: ptBRBackstage,
    'household-items': ptBRHouseholdItems,
    lists: ptBRLists,
    agenda: ptBRAgenda,
    oauth: ptBROauth,
  },
  'en-US': {
    common: enUSCommon,
    expenses: enUSExpenses,
    bills: enUSBills,
    dashboard: enUSDashboard,
    categories: enUSCategories,
    accounts: enUSAccounts,
    settings: enUSSettings,
    reports: enUSReports,
    onboarding: enUSOnboarding,
    backstage: enUSBackstage,
    'household-items': enUSHouseholdItems,
    lists: enUSLists,
    agenda: enUSAgenda,
    oauth: enUSOauth,
  },
} as const;

export const defaultNS = 'common';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pt-BR',
    defaultNS,
    supportedLngs: ['pt-BR', 'en-US'],
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'nomi-locale',
      caches: ['localStorage'],
    },
  });

export default i18n;
